import React from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);
const SalesChart = ({ data }) => {
  const chartData = {
    labels: data?.map((log) => log.date),
    datasets: [
      {
        label: "รายได้จากระบบทั้งหมด",
        data: data?.map((log) => log.revenue),
        borderColor: "#00BB9F",
        backgroundColor: "#00BB9F",
        borderDash: [5, 5],
      },
      {
        label: "รายได้จากระบบโรงรับจำนำ",
        data: data?.map((log) => log.revenue_pawns),
        borderColor: "#9C27B0",
        backgroundColor: "#9C27B0",
      },
      {
        label: "รายได้จากระบบรถ",
        data: data?.map((log) => log.revenue_cars),
        borderColor: "#EF6C00",
        backgroundColor: "#EF6C00",
      },
      {
        label: "รายได้จากระบบที่ดิน",
        data: data?.map((log) => log.revenue_lands),
        borderColor: "#2196F3",
        backgroundColor: "#2196F3",
      },
    ],
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Line
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "รายได้จากระบบ",
            },
          },
        }}
        data={chartData}
      />
    </div>
  );
};

export default SalesChart;
